/* eslint-disable @typescript-eslint/no-explicit-any */

import { GamoraErrorNotImplemented } from '../../errors/not-implemented.error.js';

/**
 * @public
 */
export enum GamoraFoundationAdapterQueryOperator {
  'UNKNOWN',
  'HAS',
  'UPSERT',
  'GET',
  'REMOVE',
  'CHAIN',
  'CLEAR',
  'LOCK',
  'UNLOCK',
}

/**
 * @public
 */
export type GamoraFoundationAdapterQueryDefaultOperand = any;

/**
 * @public
 */
export type GamoraFoundationAdapterQueryDefaultResult = any;

/**
 * @public
 */
export interface GamoraFoundationAdapterQueryArgs<
  TOperand = GamoraFoundationAdapterQueryDefaultOperand,
> {
  operand: TOperand;
  options?: any;
}

/**
 * @public
 */
export class GamoraFoundationAdapterQuery<
  TOperand = GamoraFoundationAdapterQueryDefaultOperand,
  TResult = GamoraFoundationAdapterQueryDefaultResult,
> {
  protected _operator: GamoraFoundationAdapterQueryOperator =
    GamoraFoundationAdapterQueryOperator.UNKNOWN;
  protected _options: any = null;
  private _operand: TOperand;
  constructor(args: GamoraFoundationAdapterQueryArgs<TOperand>) {
    this._operand = args.operand;
    this._options = args.options;
  }

  /**
   * Get operator
   */
  get operator() {
    return this._operator;
  }

  /**
   * Options
   */
  get options() {
    return this._options;
  }

  /**
   * Get operand
   */
  get operands(): TOperand {
    return this._operand;
  }

  /**
   * Constructs query
   * @param operand The operand
   */
  static fromOperand(operand: unknown): unknown {
    throw new GamoraErrorNotImplemented();
  }
}
